import { FaBarcode } from 'react-icons/fa'

import { Badge } from '~/components/UI/Badge'

const ProductGtins: React.FC<{ data: PublisherProduct }> = ({ data }) => {
  const dataIsValid = !!data?.gtins?.filter(Boolean)?.length
  const values = data?.gtins

  return dataIsValid ? (
    <div className="d-flex flex-wrap gap-1">
      {values?.map(item => (
        <>
          <Badge
            size="small"
            iconLeft={<FaBarcode />}
            key={`gtin_${item}`}
            text={item}
          />{' '}
        </>
      ))}
    </div>
  ) : (
    <></>
  )
}

export default ProductGtins
